<template>
  <div class="cntnt">
    <!-- Customer Care -->
    <div v-if="activeSection === 'customerCare'" id="customerCare" class="section-content customer-care-section">
      <!-- Centralized Care Banner (Inside customerCare section) -->
      <div class="flyer" style="display: flex; align-items: flex-start;">
        <img src="../assets/call-center.png" alt="Call Center" style="width: 50px; height: 65px; margin-right: 4px;">
        <div style="line-height: 1.1; font-size: 16.5px;">
          <div>
            Centralized Customer Care Number:
            <strong style="color: #FFD700;font-size: 18px;">1912</strong>
          </div>
          <div>
            কেন্দ্ৰীয় গ্ৰাহক সেৱা নম্বৰ:
            <strong style="color: #FFD700;">১৯১২</strong>
          </div>
        </div>
      </div>

      <b-row>
        <b-col cols="12">
          <h1 class="heading">APDCL Customer Care</h1>
        </b-col>
      </b-row>

      <div class="content" style="text-align:left; font-size:1rem; color:#333;">

        <strong>For any Complaint or Query:</strong><br><br>

<!-- Contact / Complaint Number -->
        <div class="contact-item">
          <img
            src="../assets/call-center.png"
            class="contact-icon-img"
            alt="Call Center"
          />

          <div class="contact-text">
            <strong>Contact / Complaint Number:</strong>

            <div>
              <span style="color:#d32f2f; font-weight:bold;">
                1912
              </span>
              <span style="font-size:14px;">
                (Calls made from within Assam)
              </span>
            </div>

            <div>
              <span style="color:#d32f2f; font-weight:bold;">
                0361-3126201 / 0361-2803200
              </span>
              <span style="font-size:14px;">
                (Calls made from outside Assam)
              </span>
            </div>
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="contact-item">
          <img
            src="../assets/whatsapp.png"
            class="contact-icon-img"
            alt="WhatsApp"
          />

          <div class="contact-text">
            <strong>WhatsApp Number:</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
              7575999666
            </span>
          </div>
        </div>

        <!-- E-mail -->
        <div class="contact-item">
          <b-icon
            icon="envelope-fill"
            class="contact-icon"
          />

          <div class="contact-text">
            <strong>E-mail:</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
              support@apdcl.org
            </span>
          </div>
        </div>

        <!-- VMN -->
        <div class="contact-item">
          <b-icon
            icon="chat-fill"
            class="contact-icon"
          />

          <div class="contact-text">
            <strong>Virtual Mobile Number (VMN):</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
              8424882488
            </span>

            <small class="contact-note">
              (To Know Your Postpaid Bill Instantly Type:
              <span class="contact-note-key">
                BILL &lt; space &gt; 12-digit consumer number
              </span>
              and send it to the above
              <strong>VMN **8424882488**</strong>.)
            </small>
          </div>
        </div>

  
        <div class="contact-item">
          <span class="contact-icon billing-arrow">▶</span>

          <div class="contact-text">
            <small class="contact-note billing-note">
              For billing-related complaints, please provide your
              <span
                class="contact-note-key"
              >
                12-digit consumer number &amp; subdivision name
              </span>.
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Key Officials -->
    <div v-if="activeSection === 'kofficial'" id="kofficial" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Key Officials Guwahati/Head Quarter (Bijulee Bhawan)</h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getKeyOfficial" :fields="KeOfficialfields" />
      </p>
    </div>

    <!-- Zone Contact -->
    <div v-if="activeSection === 'zone'" id="zone" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Zone Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getZoneData" :fields="Zonefields" />
      </p>
    </div>

    <!-- Circle Contact -->
    <div v-if="activeSection === 'circle'" id="circle" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Circle Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getCircleContact" :fields="Circlefields">
          <template v-slot:cell(email)="data">
            <span v-html="data.value"></span>
          </template>
        </b-table>
      </p>
    </div>

    <!-- Division Contact -->
    <div v-if="activeSection === 'division'" id="division" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Division Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getDivisionContact" :fields="Divisionfields">
          <template #table-caption>Official APDCL Division and AGM Level Contact Numbers</template>
        </b-table>
      </p>
    </div>

    <!-- Sub-Division Contact -->
    <div v-if="activeSection === 'subdivision'" id="subdivision" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Sub-Division Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getSubDivContact" :fields="SubDivisionfields">
          
          <template #cell(sd_name)="data">
            <div itemscope itemtype="https://schema.org/GovernmentOffice">
              <span itemprop="name">
                {{ data.value }}
              </span>
            </div>
          </template>

          <template #cell(mobile)="data">
            <div itemscope itemtype="https://schema.org/GovernmentOffice">
              <span itemprop="telephone">
                {{ data.value }}
              </span>
            </div>
          </template>

          <template #table-caption>Official APDCL Sub-Division and SDE level Complaint Numbers</template>
        </b-table>
      </p>
    </div>

    <!-- IRCA Contact -->
    <div v-if="activeSection === 'irca'" id="irca" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">
            Field Office:<span class="zone-text">IRCA Contact Details<br>(Industrial Revenue Collection Area)</span>
          </h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getIRCAContact" :fields="Ircafields" />
      </p>
    </div>

    <!-- T&C Contact -->
    <div v-if="activeSection === 'tc'" id="tc" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">T&C Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getTCContact" :fields="TCfields" />
      </p>
    </div>

    <!-- AGM Contact -->
    <div v-if="activeSection === 'agm'" id="agm" class="section-content">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">District-wise AGM(Project) Contact Details</h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getAgmContact" :fields="Agmfields" />
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

var thColor = '#0288d1';

export default {
  name: 'ContactContent',
  data() {
    return {
      show: false,
      activeSection: 'customerCare',
      KeOfficialfields: [
        { key: 'contact_person', label: 'Name',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'designation', label: 'Designation',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'phone', label: 'Phone',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Zonefields: [
        { key: 'zone_name', label: 'Zone',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'designation', label: 'Designation',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Circlefields: [
        { key: 'zone_name', label: 'Zone',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Divisionfields: [
        { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'division_name', label: 'Division',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      SubDivisionfields: [
        { key: 'circle_name', label: 'Circle',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'division_name', label: 'Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'sd_name', label: 'Sub-Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Ircafields: [
        { key: 'irca_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      TCfields: [
        { key: 'tc_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Agmfields: [
        { key: 'district', label: 'District',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getKeyOfficial',
      'getZoneData',
      'getCircleContact',
      'getDivisionContact',
      'getSubDivContact',
      'getIRCAContact',
      'getTCContact',
      'getAgmContact'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveAllContact'
    ]),

    buildPerson(row, locationLabel, officeType) {
      if (!row || !row.contact_person) return null;
      return {
        '@type': 'Person',
        name: row.contact_person,
        jobTitle: row.designation || undefined,
        telephone: row.mobile || row.phone || undefined,
        email: row.email || undefined,
        worksFor: {
          '@type': 'GovernmentOffice',
          name: locationLabel || officeType
        }
      };
    },

    injectStructuredData() {
      const people = [];

      (this.getKeyOfficial || []).forEach(r =>
        people.push(this.buildPerson(r, 'APDCL Head Quarter, Guwahati', 'Head Quarter')));

      (this.getZoneData || []).forEach(r =>
        people.push(this.buildPerson(r, r.zone_name, 'Zone Office')));

      (this.getCircleContact || []).forEach(r =>
        people.push(this.buildPerson(r, [r.zone_name, r.circle_name].filter(Boolean).join(' - '), 'Circle Office')));

      (this.getDivisionContact || []).forEach(r =>
        people.push(this.buildPerson(r, [r.circle_name, r.division_name].filter(Boolean).join(' - '), 'Division Office')));

      (this.getSubDivContact || []).forEach(r =>
        people.push(this.buildPerson(r, [r.division_name, r.sd_name].filter(Boolean).join(' - '), 'Sub-Division Office')));

      (this.getIRCAContact || []).forEach(r =>
        people.push(this.buildPerson(r, r.irca_name, 'IRCA Office')));

      (this.getTCContact || []).forEach(r =>
        people.push(this.buildPerson(r, r.tc_name, 'T&C Office')));

      (this.getAgmContact || []).forEach(r =>
        people.push(this.buildPerson(r, r.district, 'District AGM Office')));

      
      const validPeople = people.filter(Boolean);
      if (validPeople.length === 0) return;

    
      const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'GovernmentOrganization',
        name: 'Assam Power Distribution Company Limited (APDCL)',
        alternateName: 'APDCL',
        url: 'https://www.apdcl.org',
        employee: validPeople
      };

      let tag = document.getElementById('apdcl-structured-data');
      if (!tag) {
        tag = document.createElement('script');
        tag.type = 'application/ld+json';
        tag.id = 'apdcl-structured-data';
        document.head.appendChild(tag);
      }
      tag.textContent = JSON.stringify(jsonLd);
    }
  },
  watch: {
   
    getKeyOfficial() { this.injectStructuredData(); },
    getZoneData() { this.injectStructuredData(); },
    getCircleContact() { this.injectStructuredData(); },
    getDivisionContact() { this.injectStructuredData(); },
    getSubDivContact() { this.injectStructuredData(); },
    getIRCAContact() { this.injectStructuredData(); },
    getTCContact() { this.injectStructuredData(); },
    getAgmContact() { this.injectStructuredData(); }
  },
  beforeMount() {
    if(this.getKeyOfficial.length == 0) {
      this.retrieveAllContact();
    }
  },
  mounted() {
    this.injectStructuredData();
    this.$root.$on('change-contact-tab', (sectionId) => {
      this.activeSection = sectionId;
    });

    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (['customerCare', 'kofficial', 'zone', 'circle', 'division', 'subdivision', 'irca', 'tc', 'agm'].includes(hash)) {
        this.activeSection = hash;
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('change-contact-tab');
  }
}
</script>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.zone-text {
  color: #e3ac5a; 
}
.content{
  text-align: left;
  line-height: 1.8rem;
  font-size: 0.9rem;
}
.cntnt {
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 10px 30px 10px 30px;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  -webkit-overflow-scrolling: touch;
}
.customer-care-section {
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 1rem;
}
.section-content {
  overflow-y: auto;
  max-height: 70vh;
}
.flyer{
  font-family: Arial, sans-serif;
  max-width: 350px;
  background: #007BFF;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  float: right;
  margin: 1rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
table{
  text-align: left !important;
}
.contactTextStyle{
  text-shadow: 1.5px 0px 1px grey;
  font-size:1.2rem;
  font-weight:700;
  color:#03a9f4;
  letter-spacing:2px;
}
.contact-icon {

  font-size: 1rem !important;

  width: 22px;

  height: 22px;

  color: #d84315;

  margin-right: 8px;

  margin-top: 2px;

  flex-shrink: 0;

}

.contact-icon-img {

  width: 22px !important;

  height: 22px !important;

  margin-right: 8px;

  margin-top: 2px;

  object-fit: contain;

  flex-shrink: 0;

}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin: 6px 0;
  width: 100%;
}

.contact-text {
  flex: 1;
  min-width: 0;
}

.contact-icon {
  font-size: 1rem !important;
  width: 22px;
  height: 22px;
  color: #d84315;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact-icon-img {
  width: 22px !important;
  height: 22px !important;
  margin-right: 8px;
  margin-top: 2px;
  object-fit: contain;
  flex-shrink: 0;
}

.contact-note {
  font-size: 0.9rem;
  font-style: italic;
  font-weight: normal;
  color: #555;
  margin-left: 8px;
  line-height: 1.5;
}

.contact-note-key {
  color: #0d47a1;
  font-weight: bold;
}

.billing-note {
  margin-left: 0;
}

.billing-arrow {
  font-size: 1rem !important;
  width: 22px;
  height: 22px;
  line-height: 22px;
  margin-right: 8px;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .flyer {
    float: none;
    margin: 1rem auto;
  }
  .section-content {
    max-height: 50vh !important;
  }
}
@media (max-width: 576px) {
  .flyer{
    width: 100%;
    max-width: 90%;
    margin: 1rem auto;
    font-size: 0.95rem;
  }
  .flyer strong {
    font-size: 1.3rem !important;
  }
  .section-content {
    max-height: 50vh !important;
  }
}
</style>